'use client';

import H1 from '@/components/typography/h1';
import H3 from '@/components/typography/h3';
import P from '@/components/typography/p';
import { useTranslation } from 'react-i18next';

export function TermsAndConditionsContent() {
    const { t } = useTranslation();
    const articles = t('articles', { returnObjects: true }) as {
        title: string;
        text: string;
    }[];

    return (
        <div className="container mt-32 mb-10 flex max-w-[58.125rem] flex-col gap-5 px-5 lg:mt-44 lg:mb-28 lg:gap-10">
            <H1>{t('title')}</H1>

            {articles.map(({ title, text }) => {
                return (
                    <section
                        key={title}
                        className="relative flex flex-col gap-3"
                    >
                        <H3>{title}</H3>
                        <P
                            dangerouslySetInnerHTML={{
                                __html: text,
                            }}
                            className="whitespace-pre-line"
                        />
                    </section>
                );
            })}
        </div>
    );
}

TermsAndConditionsContent.displayName = 'TermsAndConditionsContent';
export default TermsAndConditionsContent;
